<template>
    <div class="dropdown">
        <label>Choose Company:</label>
        <select v-model="selectedCustomer" class="filter-group__select" @change="setCompany($event)">
            <option v-for="customer in customerList" v-bind:key="customer.id" v-bind:value="customer.value">{{ customer.text }}</option>
        </select>
    </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";

export default Vue.extend({
    name: "CompanyDrop",
    components: {},
	data() {
		return {
		customerList: {},
		selectedCustomer: "",
		};
	},
	mounted() {
		{
			this.getCustomerList();
		}
	},
	methods: {
		getCustomerList() {
			axios.get('https://new.colorwayrb.com/backend/customerlist.php').then(response => {
				this.customerList = response.data;
				console.log(response.data);
				
			});
		},
		setCompany: function(e) {
			
			e.preventDefault();
					
			this.$store.commit('updateSummaryCompany', this.selectedCustomer);
			
			console.log(this.$store.getters.getSummaryCompany);
			
			
			
		}
	}
});
</script>

<style lang="scss" scoped>
</style>